import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminRamUser } from '../../../actions/userActions';
import { MultiSelectFilter } from './MultiSelectFilter';
import { peopleOptions } from './peopleOptions';

/** DSO manager filter (multi-select). Writes the `dsoManager` filter key. */
export const DsoManagerFilter = ({ filter, handleFilterChange }) => {
  const dispatch = useDispatch();
  const dsoManagers = useSelector((state) => state.users.dsoManagers);

  useEffect(() => {
    if (!dsoManagers) {
      dispatch(getAdminRamUser());
    }
  }, [dispatch, dsoManagers]);

  return (
    <MultiSelectFilter
      label="DSO Manager"
      options={peopleOptions(dsoManagers)}
      value={filter?.dsoManager}
      onChange={(value) => handleFilterChange('dsoManager', value)}
      optionsWidth={180}
    />
  );
};

export default DsoManagerFilter;
